/*
 *  ************************************************************************
 *  *  © [2015 - 2020] Quintype Technologies India Private Limited
 *  *  All Rights Reserved.
 *  *************************************************************************
 */
export function addTargetBlankToExtLinks(el) {
  const documentNodes = el.getElementsByTagName("a") || [];
  const anchors = Array.from(documentNodes);
  anchors.forEach(anchor => {
    if (anchor.hostname && anchor.hostname !== window.location.hostname) {
      anchor.setAttribute("target", "_blank");
    }
  });
}
